import { useEffect } from "react"

import { usePrefersReducedMotion } from "@/hooks/use-prefers-reduced-motion"

import { useTypewriterReveal } from "../../hooks/use-typewriter-reveal"

type VoiceCaptionTextProps = {
  text: string
  /** The line is still being spoken; its text arrives in bursts. */
  streaming: boolean
  /** The revealed text grew: the wall keeps the newest line in view. */
  onGrow: () => void
}

/**
 * A caption's words, revealed with the chat's typewriter while the line is
 * still streaming, so a burst of transcript reads as typing and not as a jump.
 * A recogniser may revise what it heard; a revision is shown as it is rather
 * than typed over the old words.
 */
export function VoiceCaptionText({ text, streaming, onGrow }: VoiceCaptionTextProps) {
  const reducedMotion = usePrefersReducedMotion()
  const revealed = useTypewriterReveal(text, streaming && !reducedMotion, {
    plainText: true,
  })
  const shown = text.startsWith(revealed) ? revealed : text

  useEffect(() => {
    onGrow()
  }, [onGrow, shown])

  return <>{shown}</>
}
